import toString from './toString';

export default toString('hh:mm A');
